<template>
  <div class="rounded overflow-hidden bg-white border" id="filters">
    <div class="d-flex justify-content-center align-items-center bg-light p-3">
      <font-awesome-icon
        :icon="['fas', 'filter']"
        class="mr-1"
      ></font-awesome-icon>
      <span>Filtros</span>
    </div>
    <div class="px-3 py-3 mb-3">
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="form-group mb-1">
            <label>Tag Ambra</label>
            <input
              type="text"
              v-model="filters.tag_ambra"
              class="form-control"
              id="tag-ambra"
            />
          </div>

          <div class="form-group mb-1">
            <label>Tag do equipamento</label>
            <input
              type="text"
              v-model="filters.tag_machine"
              class="form-control"
              id="tag-machine"
            />
          </div>

          <div class="form-group mb-2">
            <label>Tipo Equip.</label>

            <Dropdown
              v-model="filters.machine_class_id"
              :options="non_paginated_machine_classes"
              :filter="true"
              option-label="name"
              option-value="id"
              placeholder=""
              filter-placeholder=""
              data-key="id"
              empty-message="Nenhum item encontrado"
              empty-filter-message="Nenhum item encontrado"
              class="dropdown-filter"
            />
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="form-group mb-1">
            <label>Setor</label>

            <Dropdown
              v-model="filters.sector"
              :options="company_sectors"
              :filter="true"
              option-label="name"
              option-value="id"
              placeholder="Todos"
              filter-placeholder=""
              empty-message="Nenhum item encontrado"
              empty-filter-message="Nenhum item encontrado"
              class="dropdown-filter"
              @change="onChangeSector"
            />
          </div>

          <div class="form-group mb-1">
            <label>Área</label>

            <Dropdown
              v-model="filters.area"
              :options="company_areas"
              :filter="true"
              option-label="name"
              option-value="id"
              placeholder="Todos"
              filter-placeholder=""
              empty-message="Nenhum item encontrado"
              empty-filter-message="Nenhum item encontrado"
              class="dropdown-filter"
              @change="onChangeArea"
            />
          </div>

          <div class="form-group mb-1">
            <label>Complemento</label>

            <Dropdown
              v-model="filters.complement"
              :options="company_complements"
              :filter="true"
              option-label="name"
              option-value="id"
              placeholder="Todos"
              filter-placeholder=""
              empty-message="Nenhum item encontrado"
              empty-filter-message="Nenhum item encontrado"
              class="dropdown-filter"
            />
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="form-group mb-1">
            <label>Id (de)</label>
            <input type="text" v-model="filters.id_from" class="form-control" id="id-from" />
          </div>
          <div class="form-group mb-1">
            <label>Id (até)</label>
            <input type="text" v-model="filters.id_to" class="form-control" id="id-to" />
          </div>
          <div class="form-group mb-1">
            <label>Id do equipamento</label>
            <input
              type="text"
              v-model="filters.machine_id"
              class="form-control"
              id="machine-id"
            />
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="form-group mb-1">
            <label>Categoria de Risco</label>
            <div>
              <MultiSelect
                v-model="filters.adequacy_status"
                :options="adequacy_status"
                display="chip"
                option-label="label"
                option-value="value"
                class="multiselect-custom"
              >
              </MultiSelect>
            </div>
          </div>

          <div class="form-group mb-1">
            <label>Status Equip.</label>
            <select v-model="filters.machine_status" class="form-control">
              <option value="" selected>Todos</option>
              <option value="active">Ativos</option>
              <option value="inactive">Inativos</option>
            </select>
          </div>

          <div class="form-group mb-1">
            <label>Ordenar Por</label>
            <select v-model="filters.order_by" class="form-control">
              <option value="1" selected>ID (crescente)</option>
              <option value="2">ID (decrescente)</option>
              <option value="3">Tag Ambra (crescente)</option>
              <option value="4">Tag Ambra (decrescente)</option>
              <option value="5">Resultado HRN (crescente)</option>
              <option value="6">Resultado HRN (decrescente)</option>
            </select>
          </div>

          <div class="form-group mb-3">
            <label>Pesquisa por texto</label>
            <input
              type="text"
              v-model="filters.text"
              class="form-control"
              id="text-search"
            />
          </div>

          <div class="form-check mb-3 no-print">
            <div class="d-flex align-items-center">
              <input
                :value="0"
                v-model="filters.show_only_selected_risk_categories"
                class="form-check-input"
                type="checkbox"
                id="show_only_selected_risk_categories"
              />
              <label class="form-check-label" for="show_only_selected_risk_categories">
                Exibir somente Categorias de Risco selecionadas
              </label>
            </div>
          </div>
        </div>

        <div class="col-12 mb-3 no-print">
          <div class="d-flex h-100 justify-content-end">
            <div class="my-auto">
              <button class="btn btn-success mb-1 w-100" @click="onFilter()">
                <font-awesome-icon
                  :icon="['fas', 'filter']"
                ></font-awesome-icon>
                Filtrar
              </button>

              <router-link
                :to="{
                  name: 'risk-analysis-print-machines-and-ar',
                  params: { filters: JSON.stringify(filters) },
                }"
                class="btn btn-primary mb-1 w-100"
                v-if="$route.name.includes('risk-analyses')"
              >
                <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>

                Salvar / Imprimir AR
              </router-link>

              <router-link
                :to="{
                  name: 'risk-analysis-print-machines',
                  params: { filters: JSON.stringify(filters) },
                }"
                class="btn btn-primary mb-1 w-100"
                v-if="$route.name.includes('risk-analyses')"
              >
                <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
                Salvar / Imprimir Equipamento
              </router-link>

              <router-link
                :to="{
                  name: 'action-plan-print-graphics',
                  params: { filters: JSON.stringify(filters) },
                }"
                class="btn btn-primary mb-1 w-100"
                v-if="$route.name.includes('action-plan')"
              >
                <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
                PDF Gráficos
              </router-link>

              <router-link
                :to="{
                  name: 'action-plan-print-situations',
                  params: { filters: JSON.stringify(filters) },
                }"
                class="btn btn-primary mb-1 w-100"
                v-if="$route.name.includes('action-plan')"
              >
                <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
                PDF Situações
              </router-link>

              <modal-extract :params="filters"></modal-extract>

              <button
                class="btn btn-secondary mb-1 w-100"
                @click="onClearFilters()"
              >
                <font-awesome-icon :icon="['fas', 'broom']"></font-awesome-icon>
                Limpar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'
  import MultiSelect from 'primevue/multiselect'
  import Dropdown from 'primevue/dropdown'

  import useCompanyAreas from '@/modules/CompanyArea.js'
  import useCompanyComplements from '@/modules/CompanyComplement.js'
  import useCompanySectors from '@/modules/CompanySector.js'
  import useMachineClasses from '@/modules/MachineClass.js'
  import useMachines from '@/modules/Machine.js'

  import ModalExtract from '@/components/risk-analyses/components/ModalExtract.vue'

  export default {
    emits: ['filter'],
    props: {
        riskAnalyses: Array
    },
    components: {
      MultiSelect,
      ModalExtract,
      Dropdown,
    },
    setup(props, { emit }) {
      const route = useRoute()
      const store = useStore()
      const selected_company = computed(() => store.getters.selected_company)

      const {
        filtered_company_areas,
        listCompanyAreasBySector,
        clearFilteredCompanyAreas,
      } = useCompanyAreas()
      const {
        filtered_company_complements,
        listCompanyComplementsByArea,
        clearFilteredCompanyComplements,
      } = useCompanyComplements()
      const { company_sectors, listCompanySectors } = useCompanySectors()
      const {
        non_paginated_machine_classes,
        listMachineClassesNoPaginationToCompany,
      } = useMachineClasses()
      const { machine_filters } = useMachines()

      const filters = ref({
        tag_ambra: '',
        tag_machine: '',
        sector: '',
        area: '',
        complement: '',
        machine_id: '',
        machine_class_id: '',
        id_from: '',
        id_to: '',
        machine_status: '',
        adequacy_status: [],
        text: '',
        show_only_selected_risk_categories: 0,
      })

      const adequacy_status = ref([
        { label: 'Conforme', value: 0 },
        { label: 'Aceitável', value: 1 },
        { label: 'Muito Baixo', value: 2 },
        { label: 'Baixo', value: 3 },
        { label: 'Significante', value: 4 },
        { label: 'Alto', value: 5 },
        { label: 'Muito Alto', value: 6 },
        { label: 'Extremo', value: 7 },
        { label: 'Inaceitável', value: 8 },
      ])

      onMounted(async () => {
        listCompanySectors(selected_company.value.id)
        listMachineClassesNoPaginationToCompany(selected_company.value.id)
      })

      const onChangeSector = () => {
        filters.value.area = null
        filters.value.complement = null
        clearFilteredCompanyAreas()
        clearFilteredCompanyComplements()

        listCompanyAreasBySector(filters.value.sector)
      }

      const onChangeArea = () => {
        filters.value.complement = null
        clearFilteredCompanyComplements()

        listCompanyComplementsByArea(filters.value.area)
      }

      const onFilter = () => {
        const f = {
          ...filters.value,
        }

        emit('filter', f)
      }

      const onClearFilters = () => {
        Object.keys(filters.value).forEach((key) => (filters.value[key] = ''))

        const f = {
          ...filters.value,
        }

        emit('filter', f)
      }

      return {
        company_areas: filtered_company_areas,
        company_complements: filtered_company_complements,
        company_sectors,
        non_paginated_machine_classes,
        machine_filters,
        onChangeSector,
        onChangeArea,
        adequacy_status,

        filters,
        onFilter,
        onClearFilters,
      }
    },
  }
</script>

<style lang="scss" scoped>
  label {
    margin: 0;
    font-size: 0.7rem;
  }

  input,
  select,
  .p-multiselect,
  .p-dropdown {
    height: 30px;
    font-size: 0.8rem;
  }

  .p-multiselect,
  .p-dropdown {
    width: 100%;
  }

  ::v-deep(.p-dropdown) {
    .p-dropdown-label,
    .p-inputtext {
      font-size: 0.8rem !important;
      height: 30px;
      padding: 0.3rem 1rem !important;
      color: #495057 !important;
    }

    .p-dropdown-trigger {
      margin-right: -10px;
    }

    .pi {
      font-size: 0.65rem;
      font-weight: bolder;
    }
  }

  ::v-deep(.multiselect-custom) {
    .p-multiselect-trigger {
      margin-right: -10px;
    }

    .pi {
      font-size: 0.65rem;
      font-weight: bolder;
    }

    .p-multiselect-panel .p-multiselect-header {
      padding: 0.2rem 1.5rem;
    }

    .p-multiselect-item {
      font-size: 0.7rem;
      height: 30px;
    }

    .p-multiselect-token {
      padding: 0.05rem 0.5rem;
    }

    .p-checkbox .p-checkbox-box {
      height: 15px;
      width: 15px;

      .pi {
        font-size: 0.5rem;
      }
    }
  }
</style>

<style type="text/css" media="print">
  @page {
    size: landscape !important;
  }
</style>
